export const formatCategoryData = (data) => {
  if (data) {
    for (let i = 0; i < data.length; i++) {
      data[i]["users"] = data[i]["users"]["username"];
      // status = 1 signifies published state
      data[i]["status"] = 1;
      data[i]["created_timestamp"] = data[i]["created_timestamp"]
        .replace('T', ' ')
        .replace(/\.[0-9]*Z/i, "");
      data[i]["row_id"] = i;
    };
  };

  return data;
};